export const organizerSharedGuardActivityMandatoryFieldsToggle = ['sports'];
